import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { ContainerState } from './types';

// The initial state of the templates container
export const initialState: ContainerState = {
  emailTemplate: { data: {}, loading: false, error: null },
  savedEmailTemplate: { data: {}, loading: false, error: null },
};

const emailCreateEditSlice = createSlice({
  name: 'emailCreateEditState',
  initialState,
  reducers: {
    requestCreateEmailTemplate(state, action: PayloadAction<any>) {
      state.emailTemplate.data = {};
      state.emailTemplate.loading = true;
      state.emailTemplate.error = null;
    },
    requestCreateEmailTemplateSuccess(state, action: PayloadAction<any>) {
      state.emailTemplate.data = action.payload;
      state.emailTemplate.loading = false;
    },
    requestCreateEmailTemplateError(state, action: PayloadAction<any>) {
      state.emailTemplate.error = action.payload;
      state.emailTemplate.loading = false;
    },
    requestSavedEmailTemplate(state, action: PayloadAction<any>) {
      state.savedEmailTemplate.data = {};
      state.savedEmailTemplate.loading = true;
      state.savedEmailTemplate.error = null;
    },
    requestSavedEmailTemplateSuccess(state, action: PayloadAction<any>) {
      state.savedEmailTemplate.data = action.payload;
      state.savedEmailTemplate.loading = false;
    },
    requestSavedEmailTemplateError(state, action: PayloadAction<any>) {
      state.savedEmailTemplate.error = action.payload;
      state.savedEmailTemplate.loading = false;
    },
    requestUpdateEmailTemplate(state, action: PayloadAction<any>) {
      state.emailTemplate.data = {};
      state.emailTemplate.loading = true;
      state.emailTemplate.error = null;
    },
    requestUpdateEmailTemplateSuccess(state, action: PayloadAction<any>) {
      state.emailTemplate.data = action.payload;
      state.emailTemplate.loading = false;
    },
    requestUpdateEmailTemplateError(state, action: PayloadAction<any>) {
      state.emailTemplate.error = action.payload;
      state.emailTemplate.loading = false;
    },
    clearSavedEmailTemplate(state,) {
      state.savedEmailTemplate.data = {};
    },
  },
});

export const {
  actions: emailCreateEditActions,
  reducer,
  name: sliceKey,
} = emailCreateEditSlice;
